export const ONLYNUMBERS: RegExp = /[^\d]/gi